import "@fortawesome/fontawesome-pro/css/all.css";

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import configMixin from '../util/config-mixin';
import config from './config.js';
import * as PhilaUI from '@phila/phila-ui';
import i18n from './i18n';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faMapMarkerAlt, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// Set Language
if (localStorage.getItem('lang')) {
  i18n.locale = localStorage.getItem('lang');
}

require('./config/validate.js');
store.$router = router;

library.add(faMapMarkerAlt, faUser);

// PhilaUI.Styles();

Vue.use(PhilaUI, {});

Vue.config.productionTip = false;
Vue.use(configMixin, config);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.mixin({
  computed: {
    searchResults() {
      // console.log("Search Results: ", this.$store.state.searchResults);
      return this.$store.state.searchResults;
    },
    searchData() {
      return this.$store.state.searchData;
    },
  },
  methods: {
    clearData() {
      this.$store.commit("clearData");
      this.$store.commit("setMessage", "");
      this.$store.commit("setResultData", []);
      this.$router.push({ name: 'home' });
    },
  },
});

new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount('#app');
